/*
 * Copyright (c) 2022.  Shivangi Gami
 * All Rights Reserved
 */

import * as TAG_ACTION_TYPES from './types';

const INITIAL_STATE = {
  clientTagFilter: [],
  clientTagFilterLoading: false,
  clientTagFilterErrors: {},
  taskTagFilter: [],
  taskTagFilterLoading: false,
  taskTagFilterErrors: {},
  addTaskTag: [],
  addTaskTagLoading: false,
  addTaskTagErrors: {},
  deleteTaskTag: [],
  deleteTaskTagLoading: false,
  deleteTaskTagErrors: {},
  tagClientPayload: [],
  tagClientLoading: false,
  tagClientError: {},
  tagListPayload: [],
  tagListLoading: false,
  tagListError: {},
  tagPagination: {},
  labelAddPayload: [],
  labelAddLoading: false,
  labelAddError: {},
  mergeTagsPayload: null,
  mergeTagsLoading: false,
  mergeTagsError: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const tagReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TAG_ACTION_TYPES.IN_USE_TAG_FILTER_IN_CLIENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        clientTagFilterLoading: true,
      });

    case TAG_ACTION_TYPES.IN_USE_TAG_FILTER_IN_CLIENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        clientTagFilter: action.data,
        clientTagFilterLoading: false,
        clientTagFilterErrors: {},
      });

    case TAG_ACTION_TYPES.IN_USE_TAG_FILTER_IN_CLIENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        clientTagFilterLoading: false,
        clientTagFilterErrors: action.error,
      });

    case TAG_ACTION_TYPES.IN_USE_TAG_FILTER_IN_TASK_FETCH_REQUEST:
      return Object.assign({}, state, {
        taskTagFilterLoading: true,
      });

    case TAG_ACTION_TYPES.IN_USE_TAG_FILTER_IN_TASK_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskTagFilter: action.data,
        taskTagFilterLoading: false,
        taskTagFilterErrors: {},
      });

    case TAG_ACTION_TYPES.IN_USE_TAG_FILTER_IN_TASK_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskTagFilterLoading: false,
        taskTagFilterErrors: action.error,
      });

    case TAG_ACTION_TYPES.ADD_NEW_TASK_TAG_REQUEST:
      return Object.assign({}, state, {
        addTaskTagLoading: true,
      });

    case TAG_ACTION_TYPES.ADD_NEW_TASK_TAG_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        addTaskTagLoading: false,
        addTaskTag: action.data,
        addTaskTagErrors: {},
      });

    case TAG_ACTION_TYPES.ADD_NEW_TASK_TAG_REQUEST_FAILURE:
      return Object.assign({}, state, {
        addTaskTagLoading: false,
        addTaskTagErrors: action.error,
      });

    case TAG_ACTION_TYPES.DELETE_TASK_TAG_REQUEST:
      return Object.assign({}, state, {
        deleteTaskTagLoading: true,
      });

    case TAG_ACTION_TYPES.DELETE_TASK_TAG_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        deleteTaskTagLoading: false,
        deleteTaskTag: action.data,
        deleteTaskTagErrors: {},
      });

    case TAG_ACTION_TYPES.DELETE_TASK_TAG_REQUEST_FAILURE:
      return Object.assign({}, state, {
        deleteTaskTagLoading: false,
        deleteTaskTagErrors: action.error,
      });

    case TAG_ACTION_TYPES.TAG_CLIENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        tagClientLoading: true,
      });

    case TAG_ACTION_TYPES.TAG_CLIENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        tagClientPayload: action.data,
        tagClientLoading: false,
        tagClientError: {},
      });

    case TAG_ACTION_TYPES.TAG_CLIENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        tagClientLoading: false,
        tagClientError: action.error,
      });

    case TAG_ACTION_TYPES.TAG_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        tagListLoading: true,
      });

    case TAG_ACTION_TYPES.TAG_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        tagListPayload: action.data.data,
        tagListLoading: false,
        tagListError: {},
        tagPagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
      });

    case TAG_ACTION_TYPES.TAG_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        tagListLoading: false,
        tagListError: action.error,
      });

    case TAG_ACTION_TYPES.TAG_CLIENT_UPSERT_REQUEST:
      return Object.assign({}, state, {
        labelAddLoading: true,
      });

    case TAG_ACTION_TYPES.TAG_CLIENT_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        labelAddPayload: action.data,
        labelAddLoading: false,
        labelAddError: {},
      });

    case TAG_ACTION_TYPES.TAG_CLIENT_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        labelAddLoading: false,
        labelAddError: action.error,
      });

    case TAG_ACTION_TYPES.MERGE_TAGS_REQUEST:
      return Object.assign({}, state, {
        mergeTagsLoading: true,
      });

    case TAG_ACTION_TYPES.MERGE_TAGS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        mergeTagsPayload: action.data,
        mergeTagsLoading: false,
        mergeTagsError: {},
      });

    case TAG_ACTION_TYPES.MERGE_TAGS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        mergeTagsLoading: false,
        mergeTagsError: action.error,
      });

    case TAG_ACTION_TYPES.CLEAN_TAG_PROPS:
      return Object.assign({}, state, {
        labelAddPayload: [],
        labelAddError: {},
        tagClientError: {},
        mergeTagsPayload: null,
        mergeTagsError: {},
      });

    default:
      return state;
  }
};

export default tagReducer;
